import { gql } from "@/gql/__generated__";
import { Role } from "@/gql/__generated__/graphql";
import { useQuery } from "@apollo/client";
import { useParams } from "@tanstack/react-router";
import { useLocalStorage } from "usehooks-ts";

export const GET_USER_ROLE = gql(`
  query GET_USER_ROLE {
    me {
      id
      memberships {
        role
        organization {
          id
          slug
        }
      }
    }
  }
`);

export const useUserRole = () => {
  let userRole;
  const params = useParams({ strict: false });
  const [latestOrganizationSlug] = useLocalStorage<string | null>(
    "latestOrganizationSlug",
    null
  );

  const { data, loading } = useQuery(GET_USER_ROLE, {
    fetchPolicy: "cache-and-network"
  });

  if ("organizationSlug" in params || latestOrganizationSlug) {
    userRole = data?.me.memberships
      .find(
        (member) =>
          member.organization.slug ===
          (params.organizationSlug || latestOrganizationSlug)
      )
      ?.role.toUpperCase();
  }

  const isAdmin = userRole === Role.Admin;
  const isUser = userRole === Role.User;

  return { userRole, isAdmin, isUser, loading };
};
